<script setup lang="ts">
import { IDialogueConfig } from "@/features/dream-home/composable/dialogue/types";
import DialogueBox from "@/features/dream-home/components/ui/DialogueBox.vue";
import { computed } from "vue";
import { AssetFileTypeEnum } from "../../composable/dialogue/DialogueEnum";
import { Mate } from "@/types/entity";

const props = defineProps<{
  show: boolean;
  mate: Mate;
  portrait?: string;
}>();

const emit = defineEmits<{
  (e: "update:show", show: boolean): void;
}>();

const dialogueConfig = computed<IDialogueConfig>(() => {
  return {
    sentences: [
      {
        content: "这是一个对话框预览",
        mateId: () => props.mate,
        assets: {
          portrait: {
            fileType: AssetFileTypeEnum.IMAGE,
            url: props.portrait,
          },
        },
      },
    ],
  };
});
</script>
<template>
  <VanPopup
    :show="props.show"
    @update:show="emit('update:show', $event)"
    @close="emit('update:show', false)"
    position="bottom"
    class="grid grid-rows-[auto_1fr] bg-base-300"
    round
  >
    <ThreadsNav show-back :go-back="() => emit('update:show', false)">
      <template #center> {{ $t("house.portraitPreview") }} </template>
    </ThreadsNav>
    <div class="min-h-[340px] h-full relative flex items-end">
      <DialogueBox
        v-if="dialogueConfig"
        class="h-full"
        :dialogueConfig="dialogueConfig"
        :spriteList="dialogueConfig.spriteList ?? []"
        :mateList="dialogueConfig.mateList ?? []"
        :mineMate="dialogueConfig.mineMate ?? undefined"
        :enableClick="false"
      />
    </div>
  </VanPopup>
</template>
